import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Feather, FontAwesome } from '@expo/vector-icons';
import Colors from '../../../../../constants/Colors';
import { TlyfeSelector } from '../style';
import { useSelector } from 'react-redux';
import moment from 'moment';
import getPlatformType from '../../../../../helpers/helpers';
const HoldingDepositCard = ({ children }) => {
  const modalGlobalObject = useSelector((state) => state?.tenant?.flowIdInfo);
  return (
    <>
      <View style={styles.card}>
        <Text style={styles.heading}>Holding Deposit Amount</Text>

        <View style={styles.infoBox}>
          <Feather name="info" size={16} color="#0e7490" style={styles.infoIcon} />
          <Text style={styles.infoText}>
            The Holding Deposit should be held for up to 15 days or until the agreed start date,
            whichever is later. Accepting a Holding Deposit means you must cease the marketing
            of the property with immediate effect.
          </Text>
        </View>
        <View style={{ flex: 1, flexDirection: "row", flexWrap: "wrap" }}>
          <View style={styles.row}>
            <FontAwesome name="gbp" size={16} color="#6b7280" />
            <Text style={styles.label}>Rental Amount:</Text>
            <Text style={styles.value}> £{modalGlobalObject?.open_flow_rental_offer?.rental_amount} / {modalGlobalObject?.open_flow_rental_offer?.rental_frequency}</Text>
          </View>

          <View style={styles.row}>
            <Feather name="calendar" size={16} color="#6b7280" />
            <Text style={styles.label}>Tenancy Start Date:</Text>
            <Text style={styles.value}>{modalGlobalObject?.open_flow_rental_offer?.tenancy_start_date ? moment(modalGlobalObject?.open_flow_rental_offer?.tenancy_start_date).format('YYYY-MM-DD') : "-"}</Text>
          </View>
        </View>
      </View>
      <View style={styles.card}>
        <Text style={styles.heading}>Request Holding Deposit</Text>

        <View style={styles.infoBox}>
          <Feather name="info" size={16} color="#0e7490" style={styles.infoIcon} />
          <Text style={styles.infoText}>
            Holding depsoit is usually collected from only the Lead tenant, For APT tenancies, the Tenant Fee Act stipulates that you may take a MAXIMUM of one weeks rent for holding deposit
          </Text>
        </View>
        <View style={{ flex: 1, flexDirection: "row", flexWrap: "wrap" }}>
          {children}

        </View>
      </View>
    </>

  );
};
const layoutType = getPlatformType()
const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
    borderWidth: 1,
    borderColor: '#f3f4f6',
  },
  heading: {
    fontSize: 16,
    color: Colors.light.purple,
    fontWeight: '600',
    marginBottom: 12,
  },
  infoBox: {
    flexDirection: 'row',
    backgroundColor: '#e0f2fe',
    padding: 12,
    borderRadius: 8,
    marginBottom: 16,
    alignItems: 'flex-start',
  },
  infoIcon: {
    marginRight: 8,
    marginTop: 2,
  },
  infoText: {
    color: '#0e7490',
    fontSize: 13,
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
    marginRight: 6
  },
  label: {
    fontWeight: '600',
    marginLeft: 6,
    color: '#6b7280',
  },
  value: {
    marginLeft: 6,
    color: '#6b7280',
  },
});

export default HoldingDepositCard;
